/* eslint 'jsx-a11y/anchor-is-valid': 'off', eqeqeq: 'off'  */
import React, { Component } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import Workorderlist from "./Workorderlist";
import CreateWorkOrder from "./_ModalsForms/CreateWorkOrder";
import PreventativeMaintenance from "./PreventativeMaintenanceList"; 
import CreatePreventativeMaintenance from "./_ModalsForms/CreatePreventativeMaintenance";
import '../../../Assets/EnsembleStyles/EnsNav.css';
import { connect } from 'react-redux';
import { getUserPreferences } from '../../../action/cultureAction';
import { ChangeDisplayinWorkOrderBuilding, GetMailSetting } from '../../../action/workorderAction';
import { WorkOrderRolePermission } from '../../../action/authenticateUser';
import NestedTab from './WorkorderNestedTab';
import WorkOrderKPIBoard from "./WorkOrderKPIBoard";
import WorkOrderReports from "./WorkOrderReports";
import { sendSingleAmplitudeEvent } from 'amplitude/amplitude';
//import ReportNestedTab from './WorkorderReportNestedTab';


let WorkOrderData ,WorkOrderClosedData ,PMData , PMClosedData ;


class WorkorderTab extends Component {
    componentWillMount() {
        this.props.getUserPreferences();
        this.props.WorkOrderRolePermission(24);
        this.props.GetMailSetting();
    }
    componentDidMount(){
        //ASU Sessions
        sessionStorage.setItem('ASUInvoiceTabFilter', null);
        sessionStorage.setItem('ASUMonthlyTabFilter', null);
    }
    constructor(props) {
        super(props);
        this.state = {
            id:'',
            isRedirect: false,
            activeTab: sessionStorage.getItem('activeContent') !== null ? parseInt(sessionStorage.getItem('activeContent')) : 1,
            activeContent: sessionStorage.getItem('activeContent') !== null ? parseInt(sessionStorage.getItem('activeContent')) : 1,
        };
        this.toggle = this.toggle.bind(this);
        this.FetchWorkOrderData = this.FetchWorkOrderData.bind(this);
        this.FetchWorkOrderClosedData = this.FetchWorkOrderClosedData.bind(this);
        this.FetchPMData = this.FetchPMData.bind(this);
        this.FetchPMClosedData = this.FetchPMClosedData.bind(this);
        this.redirect_WO_PM_Details = this.redirect_WO_PM_Details.bind(this);
    }

    FetchWorkOrderData(data) {
        if(data !== undefined && data !== null)
           WorkOrderData = data;
    }

    FetchWorkOrderClosedData(data){
        if(data !== undefined && data !== null)
           WorkOrderClosedData = data;
    }

    FetchPMData(data){
        if(data !== undefined && data !== null)
        PMData = data;
    }

    FetchPMClosedData(data){
        if(data !== undefined && data !== null)
        PMClosedData = data;
    }

    toggle(tab) {
        sessionStorage.setItem('activeContent',1);  
        this.props.ChangeDisplayinWorkOrderBuilding('BuildingList', '');
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
                activeContent: tab,
                isRedirect:false,
                id:''
            });
        }
    }

    redirect_WO_PM_Details(id,serialNumber){
        if(id !== null && id !== undefined && id !== '' && serialNumber !== undefined){
            if(serialNumber.substring(0,2) === "WK")
                this.setState({isRedirect:true, activeContent:1, id:id, activeTab:1 })
            else
                this.setState({isRedirect:true, activeContent:2, id:id, activeTab:2 })
        }
    }


    render(OnPremises,UserCanEdit) {
        let label = this.props.getLabels;
        let IsOnPremise = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;
        let lUserCanEdit;
        lUserCanEdit = this.props.UserCanEdit;
        lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit === 3 ? true : false;
        let active_content = null, static_content = null;
        static_content =
            <div>
                {
                    IsOnPremise ? <span className="tab_title PageTitleBar" style={{ "paddingLeft": "12px", "display":"inline-block","margin-bottom":"15px"}}>{label['WorkOrders.ComponentHeading.Text']!== undefined ? label['WorkOrders.ComponentHeading.Text'] : "Work Order Management"}</span> : ""
                }
                {
                    lUserCanEdit ? <div className="row" style={{'margin-top':'10px'}}> 
                    <div className="col-md-10" style={{"margin-top":"1px"}}>
                        <Nav tabs style={{'border-bottom':'0px'}}>  
                            <NavItem>
                                <NavLink id="tab_workorder" className={classnames({ active: this.state.activeTab == '1' }, "WO_Tab_header_link", "link_cursor","header_tab")} onClick={() => { this.toggle('1'); }} > {label['WorkOrders.WorkOrder.Text']!== undefined ? label['WorkOrders.WorkOrder.Text'] : "Work Order"}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink id="tab_preventativemaintenance" className={classnames({ active: this.state.activeTab == '2' }, "WO_Tab_header_link", "link_cursor","header_tab")} onClick={() => { this.toggle('2'); }}>{label['PreventativeMaintenance.TitleHeader.Text']!== undefined ? label['PreventativeMaintenance.TitleHeader.Text'] : "Preventative Maintenance"}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink id="tab_kpiboard" className={classnames({ active: this.state.activeTab == '3'}, "WO_Tab_header_link", "link_cursor","header_tab")} onClick={() => { this.toggle('3'); }}>{label['WorkOrders.KPIBoard.Text']!== undefined ? label['WorkOrders.KPIBoard.Text'] : "KPI Board"}{label['WorkOrders.KPIBoard.Text']}</NavLink>
                            </NavItem> 
                            <NavItem>
                                <NavLink id="tab_reports" className={classnames({ active: this.state.activeTab == '4'}, "WO_Tab_header_link", "link_cursor","header_tab")} onClick={() => { this.toggle('4'); }}>{label['WorkOrders.Reports.Text']!== undefined ? label['WorkOrders.Reports.Text'] : "Reports"}{label['WorkOrders.Reports.Text']}</NavLink>
                            </NavItem> 
                            <NavItem>
                                <NavLink id="tab_admintools" className={classnames({ active: this.state.activeTab == '5'}, "WO_Tab_header_link", "link_cursor","header_tab")} onClick={() => { this.toggle('5'); }}>{label['WorkOrderstab.AdministrativeTools.Text']!== undefined ? label['WorkOrderstab.AdministrativeTools.Text'] : "Administrative Tools"}</NavLink>
                            </NavItem> 
                        </Nav>                        
                    </div>
                    <div className="col-md-2" style={{"margin-left":"-45px"}}>
                        <div class="WOdropdown">
                            <button type="button" class="WOdropbtn"><p style={{'color':'white', 'width': '160px'}}>Create New<i className="arrowi down"></i></p></button>
                            <div class="WOdropdown-content">
                                <a onClick={() => { this.toggle('6'); }}>Work Order</a>
                                <a onClick={() => { this.toggle('7'); }}>Preventative Maintenance</a>
                            </div>
                        </div>
                    </div>
                </div>
                         :
                         <div className="row" style={{'margin-top':'10px'}}>
                            <div className="col-md-10" style={{"margin-top":"1px"}}>
                            <Nav tabs style={{'border-bottom':'0px'}}> 
                            
                                <NavItem>
                                    <NavLink className={classnames({ active: this.state.activeTab == '1' }, "WO_Tab_header_link", "link_cursor","header_tab")} onClick={() => { this.toggle('1'); }}>{label['WorkOrders.TitleHeader.Text']!== undefined ? label['WorkOrders.TitleHeader.Text'] : "Work Orders"}</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={classnames({ active: this.state.activeTab == '2' }, "WO_Tab_header_link", "link_cursor","header_tab")} onClick={() => { this.toggle('2'); }}>{label['PreventativeMaintenance.TitleHeader.Text']!== undefined ? label['PreventativeMaintenance.TitleHeader.Text'] : "Preventative Maintenance"}</NavLink>
                                </NavItem>
                            </Nav>
                            </div>
                        </div>
                }
                
            </div>

        if (this.state.activeContent == 1) {
            active_content = <div>
                <TabContent activeTab="1" className="Tab_border">
                    <TabPane tabId="1"><Workorderlist TriggerWorkOrderData={this.FetchWorkOrderData} TriggerWorkOrderClosedData={this.FetchWorkOrderClosedData} Premise={IsOnPremise} ForEquipment={false} EquipmentSummaryId={0} WorkOrderId={this.state.id} isRedirect={this.state.isRedirect}/></TabPane>
                </TabContent>
            </div>
        }
        else if (this.state.activeContent == 2) {
            active_content = <div>
                <TabContent activeTab="2" className="Tab_border">
                    <TabPane tabId="2"><PreventativeMaintenance TriggerPMData={this.FetchPMData} TriggerPMClosedData={this.FetchPMClosedData}  Premise={IsOnPremise} PMId={this.state.id} isRedirect={this.state.isRedirect}/></TabPane>
                </TabContent>
            </div>
        }
        else if (this.state.activeContent == 3) {
            sendSingleAmplitudeEvent("KPI Board");
            active_content = <div>
                <TabContent activeTab="3" className="Tab_border">
                    <TabPane tabId="3"><WorkOrderKPIBoard Premise={IsOnPremise} WorkOrderList={WorkOrderData} WorkOrderClosedList={WorkOrderClosedData} PMList={PMData} PMClosedList={PMClosedData} redirect_WO_PM_Details={this.redirect_WO_PM_Details}/></TabPane>
                </TabContent>
            </div>
        }
        else if (this.state.activeContent == 4) {
            active_content = <div>
                <TabContent activeTab="4" className="Tab_border">
                    <TabPane tabId="4"><WorkOrderReports Premise={IsOnPremise}/></TabPane>
                </TabContent>
            </div>
        }
        else if (this.state.activeContent == 5) {
            active_content = <div>
                <TabContent activeTab="5" className="Tab_border">
                    <TabPane tabId="5"><NestedTab  Premise={IsOnPremise}/></TabPane>
                </TabContent>
            </div>
        }
        else if (this.state.activeContent == 6) {
            active_content = <div>
                <TabContent activeTab="1" className="Tab_border">
                    <TabPane tabId="1"><CreateWorkOrder Premise={IsOnPremise} /></TabPane>
                </TabContent>
            </div>
        }
        else if (this.state.activeContent == 7) {
            active_content = <div>
                <TabContent activeTab="2" className="Tab_border">
                    <TabPane tabId="2"><CreatePreventativeMaintenance Premise={IsOnPremise} /></TabPane>
                </TabContent>
            </div>
        }
        return (
            <div style={{height:"100%"}} id="WorkOrderScreens">
                {static_content}
                {active_content}
            </div>
        );
    }
};
const mapStateToProps = state => {
    return {
        OnPremises: state.authService.IsOnPremise,
        UserCanEdit: state.authService.HasWorkOrderAccess,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference
    };
};
const mapDispatchToProps = dispatch => {
    return {
        getUserPreferences: () => dispatch(getUserPreferences()),
        ChangeDisplayinWorkOrderBuilding: (data, building) => dispatch(ChangeDisplayinWorkOrderBuilding(data, building)),
        WorkOrderRolePermission: (applicationId) => dispatch(WorkOrderRolePermission(applicationId)),
        GetMailSetting: () => dispatch(GetMailSetting())        
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(WorkorderTab);